import { SiafLiteApiRepository } from "../../external";

class MonitorFaturamentoService {
  constructor() {
    this.urlBase = "faturamento/monitor-faturamento";
  }

  dashboardIndicadores(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-indicadores`,
    ).patch(body);
  }

  dashboardDocumentosFiscais(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-documentos-fiscais`,
    ).patch(body);
  }

  faturamentoProdutosServicos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-faturamento-produtos-servicos`,
    ).patch(body);
  }

  faturamentoMeioPagamento(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-faturamento-meio-pagamento`,
    ).patch(body);
  }
  rankingClientes(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-clientes`,
    ).patch(body);
  }

  faturamentoMensalComparativo(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-faturamento-mensal-comparativo`,
    ).patch(body);
  }

  faturamentoGrupoProduto(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-faturamento-grupo-produto`,
    ).patch(body);
  }

  faturamentoGrupoServico(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-faturamento-grupo-servico`,
    ).patch(body);
  }

  rankingVendedoresProdutos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-vendedores-produtos`,
    ).patch(body);
  }

  rankingVendedoresServicos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-vendedores-servicos`,
    ).patch(body);
  }

  rankingServicos(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-ranking-servicos`,
    ).patch(body);
  }

  estoque(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-estoque`,
    ).patch(body);
  }

  itensSemGiro(body) {
    return new SiafLiteApiRepository(
      `${this.urlBase}/relatorios/dashboard-itens-sem-giro`,
    ).patch(body);
  }
}

export default MonitorFaturamentoService;
